/** Resets the window scroll */
export function ResetScroll() {
	window.scrollTo(0, 0);
}